import type { GrantReport } from './lookups';

function isoDaysFrom(now: Date, days: number): string {
  return new Date(now.getTime() + days * 86_400_000).toISOString().slice(0, 10);
}

/**
 * A made-up report (fictional districts, real federal programs) shown blurred behind the lead
 * gate, so visitors see the shape of what they'll get. Due dates are relative to `now` so the
 * open grants never read as closed.
 */
export function exampleGrantReport(now: Date = new Date()): GrantReport {
  return {
    districtName: 'Maple Valley School District',
    schoolName: null,
    state: 'OH',
    peersCompared: 9,
    anchor: { latitude: 40.06, longitude: -82.75, enrollment: 6800 },
    peers: [
      { districtId: 'ex-1', districtName: 'Cedar Falls City', city: null, state: 'OH', enrollment: 7100, latitude: 40.42, longitude: -82.36 },
      { districtId: 'ex-2', districtName: 'Lakeview Local', city: null, state: 'OH', enrollment: 6200, latitude: 39.72, longitude: -82.21 },
      { districtId: 'ex-3', districtName: 'Pine Ridge Exempted', city: null, state: 'OH', enrollment: 5900, latitude: 40.31, longitude: -83.18 },
      { districtId: 'ex-4', districtName: 'Willow Creek City', city: null, state: 'OH', enrollment: 7400, latitude: 39.61, longitude: -83.02 },
      { districtId: 'ex-5', districtName: 'Stone Harbor Local', city: null, state: 'OH', enrollment: 6600, latitude: 40.69, longitude: -82.71 },
      { districtId: 'ex-6', districtName: 'Fox Hollow City', city: null, state: 'OH', enrollment: 6900, latitude: 39.95, longitude: -83.44 },
    ],
    benchmark: { anchorPerPupil: null, peerMedianPerPupil: null, peersWithFunding: 0 },
    bonds: null,
    matches: [
      {
        id: 'gap:84.041', source: 'peer-gap', aln: '84.041', title: 'Impact Aid', agency: 'Department of Education', url: null,
        status: 'open', dueDate: isoDaysFrom(now, 26), awardCeiling: null, awardRange: null, peerCount: 4, peerTotalAmount: 2_800_000,
        examplePeers: [{ districtName: 'Cedar Falls City', amount: 1_100_000 }], peerDistrictIds: ['ex-1', 'ex-2', 'ex-4', 'ex-6'],
      },
      {
        id: 'gap:66.045', source: 'peer-gap', aln: '66.045', title: 'Clean School Bus Program', agency: 'Environmental Protection Agency', url: null,
        status: 'forecasted', dueDate: null, awardCeiling: null, awardRange: null, peerCount: 2, peerTotalAmount: 957_000,
        examplePeers: [{ districtName: 'Lakeview Local', amount: 520_000 }], peerDistrictIds: ['ex-2', 'ex-5'],
      },
      {
        id: 'gap:16.839', source: 'peer-gap', aln: '16.839', title: 'STOP School Violence Program', agency: 'Bureau of Justice Assistance', url: null,
        status: 'open', dueDate: isoDaysFrom(now, 17), awardCeiling: 1_000_000, awardRange: null, peerCount: 1, peerTotalAmount: 633_000,
        examplePeers: [{ districtName: 'Pine Ridge Exempted', amount: 633_000 }], peerDistrictIds: ['ex-3'],
      },
      {
        id: 'opp:example-1', source: 'open-opportunity', aln: '84.184', title: 'School Safety National Activities', agency: 'Department of Education', url: null,
        status: 'open', dueDate: isoDaysFrom(now, 40), awardCeiling: 500_000, awardRange: null, peerCount: null, peerTotalAmount: null,
        examplePeers: [], peerDistrictIds: [],
      },
    ],
  };
}
